import { reducer as websiteReducer } from './websiteSlice';
import { reducer as groupReducer } from './groupSlice';

export const mainWebsiteReducer = {
  website: websiteReducer,
  websiteGroup: groupReducer
};
